import { z } from 'zod'

import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const dental_health_insurance_type = (params: StepConfigParams) => {
  return {
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('health_insurance_type')]: z.enum([
        'statutory',
        'free_healthcare_for_civil_servants',
        'private',
      ]),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dental:steps.dental_health_insurance_type.title',
        },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        variant: 'filled',
        name: params.helperFunctions.getParamPath('health_insurance_type'),
        options: [
          {
            label: {
              type: 'translatableText',
              translationKey:
                'sharedFlows_dental:steps.dental_health_insurance_type.options.statutory',
            },
            value: 'statutory',
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_dental:steps.dental_health_insurance_type.options.free',
            },
            value: 'free_healthcare_for_civil_servants',
          },
          {
            label: {
              type: 'translatableText',
              translationKey:
                'sharedFlows_dental:steps.dental_health_insurance_type.options.private',
            },
            value: 'private',
          },
        ],
      },
    ],
    subFlow: params.subFlow,
    nextStepConfig: {
      valuePath: params.helperFunctions.getParamPath('health_insurance_type'),
      valueToStepName: {
        statutory: 'dental_missing_teeth',
        free_healthcare_for_civil_servants: 'dental_missing_teeth',
        private: 'dental_already_covered',
      },
    },
  } as const satisfies AnyStepConfiguration
}

export default dental_health_insurance_type
